// import { fetch } from './zk-fetch'
import fetch from './fetch'

/**
 * 获取wx_uid接口
 * @param {Object} params 获取wx_uid接口参数
 * @param {Object} params.code 用户code
 * @param {Object} params.app_id 小程序appid
 */
export function getWxUid(params) {
  return fetch.exec('/get_wx_uid', params)
}
// /wx_api.php?api=login

/**
 * 获取wx_uid接口
 * @param {Object} params 获取wx_uid接口参数
 * @param {Object} params.code 用户code
 * @param {Object} params.app_id 小程序appid
 */
export function submitUserInfo(params) {
  return fetch.exec('/submit_user_info', params, { method: 'POST' })
}

/**
 * 获取小程序分享内容
 * @param {*} params
 */
export function getMpShare () {
  return fetch.exec('/get_mp_share', {})
}

/**
 * 提交用户基本信息
 * @param {Object} params 提交用户基本信息参数
 * @param {Object} params.wx_uid【必须】微信用户唯一id
 * @param {Object} params.nick_name 【必须】昵称
 * @param {Object} params.avatar_url 【必须】头像
 * @param {Object} params.sex 【必须】性别
 * @param {Object} params.city 【必须】城市
 * @param {Object} params.province 【必须】省份
 * @param {Object} params.country 【必须】国家
 * @param {Object} params.language 【必须】语言
 */
export function updateUserInfo(params) {
  return fetch.exec('/submit_user_info', params, { method: 'POST' })
}

/**
 * 绑定用户手机
 * @param {Object} params 参数
 * @param {String} params.encryptedData 微信返回加密数据
 * @param {String} params.iv 微信返回密钥
 */
export function updatePhone(params) {
  return fetch.exec('/zd_bind_phone', params, { method: 'POST' })
}

/**
 * 选择(切换)用户绑定
 * @param {Object} params 参数
 * @param {String} params.user_id 用户id
 * @param {String} params.nick_name 用户名
 * @param {String} params.avatar_url 用户头像
 * @param {String} params.mobile 用户手机
 */
export function changeAccount(params) {
  return fetch.exec('/zd_select_bind', params, { method: 'POST' })
}

/**
 * 上报form-id
 * @param {Object} params 参数
 * @param {String} params.form_id 【必需】form-id
 */
export function submitFormId(params) {
  return fetch.exec('/receive_form_id', params, { method: 'POST' })
}
